customElements.define(
    'locale-selector',
    class LocaleSelector extends HTMLElement {
      constructor() {
        super();
        this.selectorModal = this.querySelector('.locale-selector__modal');
        this.openButton = document.querySelectorAll('.locale-selector__open');
        this.closeButton = this.querySelector('.locale-selector__close');
        this.localeLink = this.querySelectorAll('.submit-locale');

        this.openButton.forEach((button) => {
          button.addEventListener('click', this.open.bind(this));
        });
        this.closeButton.addEventListener('click', this.close.bind(this));
        this.localeLink.forEach((link) => {
          link.addEventListener('click', this.switchLocale.bind(this));
        });
      }

      open(event) {
        event.preventDefault();
        this.selectorModal.classList.add('active');
        this.selectorModal.addEventListener(
          'transitionend',
          () => {
            this.selectorModal.focus();
            trapFocus(this.selectorModal);
          },
          { once: true }
        );
      }

      close() {
        this.selectorModal.classList.remove('active');
        removeTrapFocus(this.openButton);
      }

      switchLocale(event) {
        if (!event.currentTarget.classList.contains('submit-locale')) return;
        event.preventDefault();
        const form = this.querySelector('form');
        form.action = '/en-us/localization';
        this.querySelector('input[name="country_code"]').value = event.currentTarget.dataset.countryCode;
        this.querySelector('input[name="language_code"]').value = event.currentTarget.dataset.langCode;
        if (form) form.submit();
      }
    }
);